export const enumErrorResponse = {
  EN: {
    default: 'General server error',
    1: 'The requested method is not allowed',
    2: 'Login information on the system has not been forwarded',
    3: 'Username is invalid format',
    4: 'Password is invalid format',
    5: 'Login data is invalid',
    6: 'Database error',
    7: 'The POST request is incorrect format',
    8: 'The field is incorrect format',
    9: 'The entry already exists in the database',
    10: 'ID has to be passed through the GET method',
    11: 'The requested ID was not found in the database',
    12: 'One of the search parameters needs to be passed',
    13: 'The GET parameter is invalid format',
    14: 'The requested user was not found in the database',
    15: 'The requested country was not found in the database',
    16: "User doesn't have permission for the requested module / action",
    17: 'The mysql table name needs to be passed',
    18: 'Value not found in selected database',
    19: 'Error passing key / value parameters',
    20: "The file format isn't allowed",
    21: 'The category was not found in the table',
    22: 'The product was not found in the table',
    23: 'The product ID was not passed',
    24: 'The variation was not found in the table',
    25: 'The selected table is not allowed to be viewed using this method',
    26: 'Unable to find user. General error',
    27: 'The requested number was not found, or is used in one of the campaigns',
    28: 'There are no users for payout for the requested period',
    29: 'Only pending payout is allowed to be deleted',
    30: 'It is necessary to pass the parameter: status',
    31: 'Unable to switch from existing to requested status',
    32: 'The contact has been taken or is already owned by the user',
    33: 'The entry has already been received in the system',
    34: 'It is necessary to pass the status through the GET method',
    35: 'The ticket does not exist or is closed for further response',
    36: 'The user does not have an active selected payment method',
    37: 'The amount you entered is not sufficient for the selected method',
    38: 'The selected method is currently unavailable for use',
    39: 'The selected method is currently inactive on your account',
    40: 'You currently have insufficient funds in your account',
    41: 'It is necessary to pass the username through the query parameter',
    42: 'Unable to find user in the database',
    43: 'A link to reset the password has already been requested for the user. Check your spam / junk',
    44: 'Unable to find token',
    45: 'You need to re-enter the password correctly',
    46: "Error in communication with third part services",
    47: "Budget for campaign has been spent. To reactivate campaign increase budget",
    48: "Campaign rejections comment is missing",
    49: "Campaign creative rejections comment is missing",
    50: "Field character length too long",
    51: "File error upload",
    52: "Can't edit finalized payments",
    53: "Validation errors",
    54: "You need at least one of: Sub ID, Country or Device",
    55: "Subject length exceeds 256 characters",
    56: "Selected email not in allowed list of emails",
    57: "Content of email not valid format. Base64 required",
    58: "Newsletter can only be switched to status in-process",
    59: "Unable to find or edit newsletter due to it's status",
    60: "Parameter user_id is required for action"
  },
  BA: {
    default: 'Nedefinisana greška na serveru',
    1: 'Metoda zahtjeva nije dozvoljena',
    2: 'Podaci za prijavu na sistemu nisu proslijeđeni',
    3: 'Korisničko ime nije dozvoljenog formata',
    4: 'Lozinka nije dozvoljenog formata',
    5: 'Podaci za prijavu nisu validni',
    6: 'Greška sa bazom podataka',
    7: 'POST zahtjev nije ispravnog formata',
    8: 'Polje nije ispravnog formata',
    9: 'Unos već postoji u bazi podataka',
    10: 'Potrebno kroz GET proslijediti ID',
    11: 'Traženi ID nije pronađen u bazi',
    12: 'Potrebno je proslijediti jedan od parametara za pretragu',
    13: 'GET parametar nije ispravnog formata',
    14: 'Traženi korisnik nije pronađen u bazi',
    15: 'Tražena država nije pronađena u bazi',
    16: 'Korisnik nema odobrenje za traženi modul / akciju',
    17: 'Potrebno je proslijediti naziv mysql tablice',
    18: 'Vrijednost nije pronađena u selektovanoj tablici',
    19: 'Greška u prosleđivanju key / value parametara',
    20: 'Format fajla nije dozvoljen',
    21: 'Kategorija nije pronađena u tablici',
    22: 'Proizvod nije prinađen u tablici',
    23: 'ID proizvoda nije proslijeđen',
    24: 'Varijacija nije pronađena u tablici',
    25: 'Selektovana tablica nije dozvoljena za pregled putem ove metode',
    26: 'Nije moguće pronaći korisnika. Generalna greška',
    27: 'Traženi broj nije pronađen, ili se koristi u nekoj od kampanja',
    28: 'Za traženi period ne postoje korisnici za isplatu',
    29: 'Dozvoljeno je obrisati samo payment koji je na čekanju',
    30: 'Potrebno je proslijediti parametar: status',
    31: 'Nije moguće prebaciti iz postojećeg u traženi status',
    32: 'Kontakt je preuzet ili je već u vlasništvu korisnika',
    33: 'Unos je već zaprimljen u sistem',
    34: 'Potrebno je proslijediti status kroz GET',
    35: 'Tiket ne postoji ili je zatvoren za dalje odgovaranje',
    36: 'Korisnik nema aktivnu odabranu metodu za isplatu',
    37: 'Za odabranu metodu iznos koji ste unijeli nije dovoljan',
    38: 'Odabranu metodu trenutno nije moguće koristiti',
    39: 'Odabrana metoda trenutno nije aktivna na Vašem računu',
    40: 'Trenutno nemate dovoljno sredstava na računu',
    41: 'Potrebno je proslijediti username kroz query parametar',
    42: 'Nije moguće pronaći korisnika u bazi',
    43: 'Za korisnika je već zatražen link za restartovanje passworda. Provjerite spam / junk',
    44: 'Nije moguće pronaći token',
    45: 'Potrebno je ispravno ponoviti unos passworda',
    46: "Greška u komunikaciji sa externim servisom",
    47: "Kampanja je potrošila ukupni budžet, potrebno povećati budžet kako bi se kampanja ponovo aktivirala",
    48: "Potrebno je unijeti razlog odbijanja kampanje",
    49: "Potrebno je unijeti razlog odbijanja kreative",
    50: "Dužina unosa prelazi dozvoljenu",
    51: "Greška prilikom uploada fajla",
    52: "Nije moguće editovati završenu isplatu",
    53: "Upisi nisu prošli validaciju",
    54: "Potrebno je proslijediti jedan od parametara [subid, country, device]",
    55: "Dužina naslova email poruke prelazi dozvoljenu. Dozvoljena dužina iznosi 256 karaktera",
    56: "Selektovana email adresa se ne nalazi u listi dozvoljeni.",
    57: "Sadržaj email-a nije ispravnog formata. Potrebno je korisitit base64 kripciju.",
    58: "Newsletter je moguće prebaciti samo u status in-process.",
    59: "Newsletter nije moguće pronaći ili editovati radi njegovog trenutnog statusa.",
    60: "Za traženu akciju potrebno je proslijediti i user_id"
  },
};